export default __webpack_public_path__ + "static/media/showcase.36c5c8c1.jpg";